/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Allowance_ConditionsInputs */



/**
* | output |
* | --- |
* | "Conditions per perk" |
*
* @param {Perks_Allowance_ConditionsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_allowance_conditions = /** @type {((inputs?: Perks_Allowance_ConditionsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Allowance_ConditionsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Условий на привилегию")
	return /** @type {LocalizedString} */ ("Conditions per perk")
});